<template>
  <div class="completion-message-step">
    <Typography variant="h-5">
      This is the message users see after finishing the survey. We've added a default, but feel free
      to make it your own.
    </Typography>

    <LearningCardEditor
      ref="editor"
      :display-name="displayName"
      :content="content"
      :client-id="clientId"
      title-label="Completion Title*"
      placeholder="Completion message content"
      @update:displayName="$emit('update:displayName', $event)"
      @update:content="$emit('update:content', $event)"
    />
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import LearningCardEditor from "@/components/module-builder/components/LearningCardEditor.vue";

export default {
  name: "CompletionMessageStep",
  components: {
    Typography,
    LearningCardEditor,
  },
  props: {
    displayName: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    clientId: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ["update:displayName", "update:content"],
  methods: {
    validate() {
      return this.$refs.editor?.validate() ?? true;
    },
  },
};
</script>

<style scoped>
.completion-message-step {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
